export default __webpack_public_path__ + "static/media/dinersclub.d4e68a74.svg";